import { ServicesContainer } from "utility/connections";

import GoogleSheetConnectedExtraConnectionDetails from "external/destination/google_sheet/extra_details";

import redirectToGoogleSheetPage from "./destination/google_sheet/connect_handler";
import GoogleSheetCoverImage from "./destination/google_sheet/CoverImage";
import redirectToJiraConnectPage from "./destination/jira/connect_handler";
import JiraCoverImage from "./destination/jira/CoverImage";
import redirectToMattermostConnectPage from "./destination/mattermost_webhook/connect_handler";
import MattermostCoverImage from "./destination/mattermost_webhook/CoverImage";
import redirectToPagerdutyOauthUrl from "./destination/pagerduty/connect_handler";
import PagerdutyCoverImage from "./destination/pagerduty/CoverImage";
import redirectToSlackOauthUrl from "./destination/slack/connect_handler";
import SlackCoverImage from "./destination/slack/CoverImage";
import redirectToSplunkCloudWebhookConnectPage from "./destination/splunk_cloud_webhook/connect_handler";
import SplunkCloudWebhookCoverImage from "./destination/splunk_cloud_webhook/CoverImage";
import redirectToSplunkWebhookConnectPage from "./destination/splunk_webhook/connect_handler";
import SplunkWebhookCoverImage from "./destination/splunk_webhook/CoverImage";
import redirectToTeamsWebhookConnectPage from "./destination/teams_webhook/connect_handler";
import TeamsWebhookCoverImage from "./destination/teams_webhook/CoverImage";
import redirectToTinesWebhookConnectPage from "./destination/tines_webhook/connect_handler";
import TinesWebhookCoverImage from "./destination/tines_webhook/CoverImage";
import redirectToWebexWebhookConnectPage from "./destination/webex_webhook/connect_handler";
import WebexWebhookCoverImage from "./destination/webex_webhook/CoverImage";
import redirectToWebhookConnectPage from "./destination/webhook/connect_handler";
import WebhookCoverImage from "./destination/webhook/CoverImage";
import redirectToZapierWebhookConnectPage from "./destination/zapier_webhook/connect_handler";
import ZapierWebhookCoverImage from "./destination/zapier_webhook/CoverImage";

// -----------------------------------------------------------------------------

const ExternalDestinations: ServicesContainer = {
  importanceOrder: [
    ["jira-sync"],
    ["slack", "slack_code"],
    ["pagerduty"],
    ["webhook_url"],
    ["zapier_webhook"],
    ["splunk_webhook"],
    ["splunk_cloud_webhook"],
    ["tines_webhook"],
    ["webex_webhook"],
  ],
  services: [
    {
      name: "google_sheet",
      label: "Google Sheet Sync",
      coverImage: GoogleSheetCoverImage,
      onConnect: redirectToGoogleSheetPage,
      searchTerms: ["google", "sheet", "sheets"],
      url: "google_sheet",
      onExtraConnectionDetails: GoogleSheetConnectedExtraConnectionDetails,
    },
    {
      name: "jira-sync",
      label: "Jira Cloud Issue Sync",
      coverImage: JiraCoverImage,
      onConnect: redirectToJiraConnectPage,
      searchTerms: ["atlassian", "jira", "issue"],
      url: "jira",
      notifications: true,
    },
    {
      name: "Mattermost",
      label: "Mattermost",
      coverImage: MattermostCoverImage,
      onConnect: redirectToMattermostConnectPage,
      searchTerms: ["Mattermost", "mm", "matter"],
      url: "mattermost",
      notifications: true,
    },
    {
      name: "pagerduty",
      label: "Pagerduty",
      coverImage: PagerdutyCoverImage,
      onConnect: redirectToPagerdutyOauthUrl,
      searchTerms: [],
      url: "pagerduty",
      notifications: true,
    },
    {
      name: "slack",
      alternativeNames: ["slack_code"],
      label: "Slack",
      coverImage: SlackCoverImage,
      onConnect: redirectToSlackOauthUrl,
      searchTerms: [],
      url: "slack",
      notifications: true,
    },
    {
      name: "splunk_webhook",
      label: "Splunk Webhooks",
      coverImage: SplunkWebhookCoverImage,
      onConnect: redirectToSplunkWebhookConnectPage,
      searchTerms: [],
      url: "splunk_webhook",
      notifications: true,
    },
    {
      name: "splunk_cloud_webhook",
      label: "Splunk Cloud Webhooks",
      coverImage: SplunkCloudWebhookCoverImage,
      onConnect: redirectToSplunkCloudWebhookConnectPage,
      searchTerms: [],
      url: "splunk_cloud_webhook",
      notifications: true,
    },
    {
      name: "tines_webhook",
      label: "Tines Webhooks",
      coverImage: TinesWebhookCoverImage,
      onConnect: redirectToTinesWebhookConnectPage,
      searchTerms: [],
      url: "tines_webhook",
      notifications: true,
    },
    {
      name: "teams_webhook",
      label: "Microsoft Teams Webhooks",
      coverImage: TeamsWebhookCoverImage,
      onConnect: redirectToTeamsWebhookConnectPage,
      searchTerms: [],
      url: "teams_webhook",
      notifications: true,
    },
    {
      name: "webhook_url",
      label: "Webhooks",
      coverImage: WebhookCoverImage,
      onConnect: redirectToWebhookConnectPage,
      searchTerms: [],
      url: "webhook",
      notifications: true,
    },
    {
      name: "webex_webhook",
      label: "Cisco Webex Teams",
      coverImage: WebexWebhookCoverImage,
      onConnect: redirectToWebexWebhookConnectPage,
      searchTerms: [],
      url: "webex_webhook",
      notifications: true,
    },
    {
      name: "zapier_webhook",
      label: "Zapier Webhooks",
      coverImage: ZapierWebhookCoverImage,
      onConnect: redirectToZapierWebhookConnectPage,
      searchTerms: [],
      url: "zapier_webhook",
      notifications: true,
    },
  ],
};

export default ExternalDestinations;
